import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { useModuleOffers } from '../hooks/useModuleOffers';
import { ModuleOfferDetails } from './modules/ModuleOfferDetails';

const RequestedOffer = ({ moduleKey, onClose }) => {
  const { offers, loading, error, reload } = useModuleOffers();
  const offer = offers.find((item) => item.key === moduleKey);
  return <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}><DialogContent className="!bg-[var(--carte)] !text-[var(--texte)] !w-[calc(100vw-24px)] !max-w-2xl !max-h-[90dvh] overflow-y-auto !z-[170]" overlayClassName="!z-[160]" data-testid="requested-module-dialog" closeTestId="requested-module-close"><DialogHeader><DialogTitle data-testid="requested-module-title">{offer?.label || 'Module complémentaire'}</DialogTitle><DialogDescription>Offre mensuelle · par établissement</DialogDescription></DialogHeader>
    {loading && !offer && <p role="status" data-testid="requested-module-loading">Chargement de l’offre…</p>}
    {error && <p role="alert" data-testid="requested-module-error">{error}<button type="button" onClick={reload} className="module-link" data-testid="requested-module-retry">Réessayer</button></p>}
    {offer && <ModuleOfferDetails offer={offer} onChanged={reload} onClose={onClose} />}
    {!loading && !error && !offer && <p data-testid="requested-module-unavailable">Cette offre n’est pas disponible.</p>}
  </DialogContent></Dialog>;
};

export const UpsellMount = () => {
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    const handler = (event) => { if (event.detail?.addonKey) setSelected(event.detail.addonKey); };
    window.addEventListener('upsell:show', handler);
    return () => window.removeEventListener('upsell:show', handler);
  }, []);
  return selected ? <RequestedOffer moduleKey={selected} onClose={() => setSelected(null)} /> : null;
};
export default UpsellMount;